import gql from 'graphql-tag';

export const QUERY_ASSETS = gql`
  fragment assetsFields on Asset {
    id
    subtype
    file {
      url
      alternativeText
      width
      height
    }
    channels
  }
`;
